import { amplifyClient, getEndpointV2 } from 'api';
import { createApiSlice } from 'helpers/createApiSlice';
import { StateCarrierInfo } from 'modal/catalogs/new-carrier/utils';
import { StateClientInfo } from 'modal/catalogs/new-client/utils';
import { StateLocationInfo } from 'modal/catalogs/new-location/utils';
import { StateMerchandiseInfo } from 'modal/catalogs/new-merchandise/utils';
import { StateOperatorInfo } from 'modal/catalogs/new-operator/utils';
import { StateTrailerInfo } from 'modal/catalogs/new-trailer/utils';
import { StateUnitInfo } from 'modal/catalogs/new-unit/utils';
import { call } from 'redux-saga/effects';

type Payload = {
  id: string;
  catalogName: string;
};

type Data =
  | StateCarrierInfo
  | StateLocationInfo
  | StateMerchandiseInfo
  | StateOperatorInfo
  | StateTrailerInfo
  | StateUnitInfo
  | StateClientInfo;

export const getDataEdit = createApiSlice<unknown, Payload>({
  name: 'getDataEdit',
  *tryGenerator(_, { payload: { id, catalogName } }) {
    const data: Data = yield call(amplifyClient, {
      method: 'get',
      url: getEndpointV2({
        path: '/api/documents/catalogs/:id',
        urlParams: { id },
        params: { catalogName },
      }),
    });

    return data;
  },
});

export const delCatalog = createApiSlice<unknown, Payload>({
  name: 'delCatalog',
  *tryGenerator(_, { payload: { catalogName, id } }) {
    yield call(amplifyClient, {
      method: 'del',
      url: getEndpointV2({
        path: '/api/documents/catalogs/:id',
        params: { catalogName },
        urlParams: { id },
      }),
    });

    return null;
  },
});

type PayloadAddCatalog = {
  data:
    | StateCarrierInfo
    | StateLocationInfo
    | StateMerchandiseInfo
    | StateOperatorInfo
    | StateTrailerInfo
    | StateUnitInfo
    | StateClientInfo;
  catalogName: string;
  source?: string;
  id?: string;
};

export const addCatalog = createApiSlice<unknown, PayloadAddCatalog>({
  name: 'addCatalog',
  *tryGenerator(_, { payload: { data, catalogName, source = 'table' } }) {
    yield call(amplifyClient, {
      method: 'post',
      url: getEndpointV2({
        path: '/api/documents/catalogs',
        params: { catalogName, source },
      }),
      data: { ...data, trip: true },
    });

    return null;
  },
});

export const editCatalog = createApiSlice<unknown, PayloadAddCatalog>({
  name: 'editCatalog',
  *tryGenerator(_, { payload: { data, catalogName, source = 'table', id } }) {
    yield call(amplifyClient, {
      method: 'put',
      url: getEndpointV2({
        path: '/api/documents/catalogs/:id',
        params: { catalogName, source },
        urlParams: { id },
      }),
      data,
    });

    return null;
  },
});
